import React from "react";

const VARIANTS = {
  primary:   "bg-brand-500 text-white hover:bg-brand-600 shadow-elevation-1",
  secondary: "bg-surface-hover text-content-primary border border-surface-border hover:bg-gray-100",
  ghost:     "text-brand-500 hover:bg-brand-50",
  danger:    "bg-danger-500 text-white hover:bg-danger-600",
  success:   "bg-success-500 text-white hover:bg-success-600",
};

const SIZES = {
  sm: "px-3 py-1.5 text-caption gap-1.5",
  md: "px-4 py-2 text-body gap-2",
  lg: "px-5 py-2.5 text-subtitle gap-2",
};

const Button = ({
  children,
  variant = "primary",
  size = "md",
  disabled = false,
  loading = false,
  icon = null,
  className = "",
  type = "button",
  ...props
}) => {
  return (
    <button
      type={type}
      disabled={disabled || loading}
      className={`
        inline-flex items-center justify-center
        font-medium rounded-button
        transition-colors duration-150
        disabled:opacity-50 disabled:cursor-not-allowed
        ${VARIANTS[variant] || VARIANTS.primary}
        ${SIZES[size] || SIZES.md}
        ${className}
      `.trim()}
      {...props}
    >
      {loading ? (
        <span className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" />
      ) : icon ? (
        <span className="w-4 h-4 flex-shrink-0 flex items-center justify-center">{icon}</span>
      ) : null}
      {children}
    </button>
  );
};

export default Button;
